// Blog/News data for CEPRES International University
// Static content - can be connected to CMS later

export const blogCategories = [
  'All',
  'News',
  'Events',
  'Student Success',
  'Research',
  'Community',
];

export const blogPosts = [
  {
    id: 'graduation-2025',
    title: 'CEPRES Celebrates 10th Anniversary Graduation Ceremony',
    excerpt: 'Over 200 students received their degrees at the grand ceremony held in Gbarnga City, marking a decade of excellence in healthcare education.',
    category: 'Events',
    author: 'Communications Office',
    date: '2025-01-15',
    image: 'https://customer-assets.emergentagent.com/job_479182d4-7fde-4a87-91a5-42a6ac4fac5e/artifacts/bnx3f2sc_WhatsApp%20Image%202026-02-04%20at%2017.35.13.jpeg',
    featured: true,
    content: `
      CEPRES International University celebrated a historic milestone as over 200 graduates received their degrees at the 10th anniversary graduation ceremony. The event, held at the main campus in Gbarnga City, brought together faculty, students, families, and distinguished guests from across Liberia.

      Dr. Mogana S. Flomo, Jr., Founder and President, delivered an inspiring keynote address, reflecting on the university's journey from its founding during the 2014 Ebola crisis to becoming a leading healthcare education institution in West Africa.

      "Ten years ago, we started with a vision to transform healthcare education in Liberia. Today, we celebrate over 1,000 graduates who are making a difference in communities across our nation," Dr. Flomo stated.

      The graduating class included students from all 19 degree programs, with the largest cohort coming from the Bachelor of Public Health program.
    `,
  },
  {
    id: 'partnership-who',
    title: 'CIU Partners with WHO for Community Health Training Initiative',
    excerpt: 'New partnership will train 500 community health workers across Bong County over the next two years.',
    category: 'News',
    author: 'Dr. Sarah Johnson',
    date: '2025-01-08',
    image: 'https://customer-assets.emergentagent.com/job_479182d4-7fde-4a87-91a5-42a6ac4fac5e/artifacts/mp7kzwiz_WhatsApp%20Image%202026-02-04%20at%2017.35.15%20%284%29.jpeg',
    featured: true,
    content: `
      CEPRES International University has signed a landmark partnership agreement with the World Health Organization (WHO) to train 500 community health workers across Bong County.

      The initiative, which will span two years, aims to strengthen primary healthcare delivery in rural communities. Participants will receive certificates upon completion and be equipped with essential skills in disease surveillance, maternal health, and health education.

      "This partnership represents a significant step forward in our mission to improve public health outcomes in Liberia," said the Dean of Health Sciences.
    `,
  },
  {
    id: 'student-research-award',
    title: 'CIU Student Wins National Research Award for Malaria Study',
    excerpt: 'Final year student Mary Weah receives recognition for groundbreaking research on malaria prevention strategies.',
    category: 'Student Success',
    author: 'Research Department',
    date: '2024-12-20',
    image: 'https://customer-assets.emergentagent.com/job_479182d4-7fde-4a87-91a5-42a6ac4fac5e/artifacts/vfz74n9l_WhatsApp%20Image%202026-02-04%20at%2017.35.14%20%285%29.jpeg',
    featured: false,
    content: `
      Mary Weah, a final year Bachelor of Public Health student, has been awarded the National Research Excellence Award for her innovative study on community-based malaria prevention strategies.

      Her research, conducted in collaboration with the National Public Health Institute, demonstrated a 40% reduction in malaria cases in pilot communities that implemented her recommended interventions.

      "This recognition belongs to CEPRES and all my professors who guided me through this journey," Mary said during the award ceremony.
    `,
  },
  {
    id: 'new-it-lab',
    title: 'State-of-the-Art IT Laboratory Opens at CIU Campus',
    excerpt: 'New computer lab with 50 workstations will support vocational training programs and digital skills development.',
    category: 'News',
    author: 'IT Department',
    date: '2024-12-10',
    image: 'https://customer-assets.emergentagent.com/job_479182d4-7fde-4a87-91a5-42a6ac4fac5e/artifacts/yfrf73c9_WhatsApp%20Image%202026-02-04%20at%2017.35.14%20%287%29.jpeg',
    featured: false,
    content: `
      CEPRES International University has inaugurated a new state-of-the-art IT laboratory equipped with 50 modern workstations, high-speed internet, and the latest software for technical training.

      The laboratory will primarily serve students enrolled in the Institute of Professional Studies' IT programs, including Computer Literacy, Web Development, and the Diploma in Information Technology.

      The facility was made possible through a generous donation from the African Development Bank's education initiative.
    `,
  },
  {
    id: 'health-outreach',
    title: 'CIU Students Conduct Free Health Screening in Rural Communities',
    excerpt: 'Over 1,000 residents received free health screenings during the annual community outreach program.',
    category: 'Community',
    author: 'Community Health Department',
    date: '2024-11-25',
    image: 'https://customer-assets.emergentagent.com/job_479182d4-7fde-4a87-91a5-42a6ac4fac5e/artifacts/mp7kzwiz_WhatsApp%20Image%202026-02-04%20at%2017.35.15%20%284%29.jpeg',
    featured: false,
    content: `
      Students from the Bachelor of Community Health program conducted their annual health outreach, providing free screenings for blood pressure, diabetes, and malaria to over 1,000 residents in rural Bong County.

      The week-long program also included health education sessions on nutrition, hygiene, and disease prevention. Faculty members supervised the activities while students gained valuable hands-on experience.

      "These outreach programs are essential to our mission of training healthcare professionals who understand and serve their communities," explained the program coordinator.
    `,
  },
  {
    id: 'agriculture-innovation',
    title: 'Sustainable Agriculture Students Launch Campus Farm Project',
    excerpt: 'Student-led initiative transforms unused campus land into a model sustainable farm.',
    category: 'Research',
    author: 'Agriculture Department',
    date: '2024-11-15',
    image: 'https://images.unsplash.com/photo-1585094659595-04a44bcba305?w=800',
    featured: false,
    content: `
      Students enrolled in the BSc Sustainable Agriculture program have launched an ambitious campus farm project, transforming two hectares of unused land into a model sustainable farm.

      The project incorporates agroecological principles learned in the classroom, including crop rotation, composting, and integrated pest management. Produce from the farm will supply the campus cafeteria and generate income for student scholarships.

      The initiative has attracted attention from the Ministry of Agriculture as a potential model for rural agricultural development.
    `,
  },
  {
    id: 'alumni-network',
    title: 'CIU Alumni Association Launches Mentorship Program',
    excerpt: 'New program connects current students with successful graduates for career guidance and networking.',
    category: 'News',
    author: 'Alumni Relations',
    date: '2024-11-01',
    image: 'https://customer-assets.emergentagent.com/job_479182d4-7fde-4a87-91a5-42a6ac4fac5e/artifacts/ptyry2rh_WhatsApp%20Image%202026-02-04%20at%2017.35.12%20%283%29.jpeg',
    featured: false,
    content: `
      The CEPRES International University Alumni Association has launched a mentorship program to connect current students with successful graduates working in healthcare and related fields.

      The program matches students based on their program of study and career interests, providing them with guidance, networking opportunities, and real-world insights from professionals who walked the same path.

      Over 100 alumni have already volunteered to serve as mentors in the program's inaugural year.
    `,
  },
  {
    id: 'accreditation-renewal',
    title: 'CIU Receives Full Accreditation Renewal from National Commission',
    excerpt: 'All 19 degree programs receive continued accreditation following successful institutional review.',
    category: 'News',
    author: 'Academic Affairs',
    date: '2024-10-20',
    image: 'https://customer-assets.emergentagent.com/job_479182d4-7fde-4a87-91a5-42a6ac4fac5e/artifacts/bnx3f2sc_WhatsApp%20Image%202026-02-04%20at%2017.35.13.jpeg',
    featured: false,
    content: `
      CEPRES International University has received full accreditation renewal from the National Commission on Higher Education following a comprehensive institutional review.

      The accreditation covers all 19 degree programs and validates the university's commitment to maintaining high academic standards. Reviewers commended the institution's innovative accelerated learning model and strong community engagement.

      "This accreditation affirms our dedication to providing quality education that meets national and international standards," said the Vice President for Academic Affairs.
    `,
  },
];

// Get featured posts
export const getFeaturedPosts = () => blogPosts.filter(post => post.featured);

// Get posts by category
export const getPostsByCategory = (category) => {
  if (category === 'All') return blogPosts;
  return blogPosts.filter(post => post.category === category);
};

// Get single post by ID
export const getPostById = (id) => blogPosts.find(post => post.id === id);
